import CardCommon from '@/pages/opinion/components/CardCommon';
import React, { useState } from 'react';
import { useIntl } from 'umi';
import ChannelsLanguageChart from '../ChannelsLanguageChart';
import { lineIcon, pieIcon } from '@/pages/opinion/constants/chart';
export default function (props: any) {
  const { formatMessage } = useIntl();

  const {
    filter,
    regionType,
    data,
    defaultSelected,
    chartOptions,
    type: chartType,
  } = props;

  const [type, setType] = useState(chartType || 'line');

  return (
    <CardCommon
      title={formatMessage({ id: 'Mentions' })}
      handleOperationsOnClick={(item) => {
        setType(item.symbol);
      }}
      defaultOperation={type}
      operations={[lineIcon, pieIcon]}
      empty={
        !Array.isArray(data?.timeline_of_mentions) ||
        data?.timeline_of_mentions.length === 0
      }
    >
      {/* 这里应该也可以接入通用的卡片 */}
      <ChannelsLanguageChart
        type={type}
        dataType={'region'}
        regionType={regionType}
        data={data}
        defaultSelected={defaultSelected}
        chartOptions={chartOptions}
        filter={filter}
        showTitle={false}
        lang={undefined}
        isVersion={false}
        statsDetailType={`performance-${regionType}`}
        height={284}
        handleStatsDetailOnClick={props.handleStatsDetailOnClick}
      ></ChannelsLanguageChart>
    </CardCommon>
  );
}
